import { Component } from '@angular/core';
import { NavController,NavParams } from 'ionic-angular';



@Component({
  templateUrl: 'build/pages/messageview/messageview.html',
})
export class MessageviewPage {



  jobinfos: any;

  constructor(private navCtrl: NavController,public navParams: NavParams) {
this.jobinfos = navParams.data;

  }

}
